import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component for Mobile Call Awareness Phase 1 — the metadata-only call
// observer (CONEK-4055). Arms the native CallObserverService (no microphone, no
// recording) whenever `calls.metadata_capture` is enabled for the tenant.
//
// Distinct from `bridge--call-capture` (Phase 2 audio recording). Mounted on
// the mobile layout so the observer is armed for the whole session and survives
// the rep switching to the dialer to place/answer a call. It deliberately does
// NOT disarm on disconnect — the native service is START_NOT_STICKY and dies
// with the app process, so leaving a page must not stop call observation.
//
// iOS receives the `arm` too but the iOS shell ignores it (Apple blocks
// third-party call observation); there the post-call card stays manual-only.
export default class extends BridgeComponent {
  static component = "call-observer"

  static values = {
    armed: { type: Boolean, default: false },
    ownLine: String,
  }

  connect() {
    super.connect()
    if (!this.armedValue) return

    this.send("arm", {
      own_line: this.ownLineValue || null,
    })
  }
}
